import { useQuery } from '@tanstack/react-query';
import { adminApi } from '../api/adminApi';
import { adminKeys } from '../api/adminQueryKeys';
export function useAdminToolLogs(filters, cursor) {
    return useQuery({
        queryKey: adminKeys.toolLogsList(filters, cursor),
        queryFn: () => adminApi.getToolLogs(filters, cursor),
    });
}
export function useAdminToolRuns(toolName, cursor) {
    return useQuery({
        queryKey: adminKeys.toolRunsList(toolName, cursor),
        queryFn: () => adminApi.getToolRuns(toolName, cursor),
    });
}
export function useAdminToolNames() {
    return useQuery({
        queryKey: adminKeys.toolNames(),
        queryFn: () => adminApi.getToolNames(),
        staleTime: 5 * 60 * 1000,
    });
}
